import { render, staticRenderFns } from "./item-picker-table.vue?vue&type=template&id=cb8789ec"
import script from "./item-picker-table.vue?vue&type=script&lang=js"
export * from "./item-picker-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb8789ec')) {
      api.createRecord('cb8789ec', component.options)
    } else {
      api.reload('cb8789ec', component.options)
    }
    module.hot.accept("./item-picker-table.vue?vue&type=template&id=cb8789ec", function () {
      api.rerender('cb8789ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/campaign-template/item-picker-table.vue"
export default component.exports